import React from 'react';
import styles from './index.module.scss';
import { Typography } from 'antd';
import { MdContentCopy } from 'react-icons/md';
import { IoCheckmarkCircle } from 'react-icons/io5';
const { Paragraph } = Typography;
const TextCopy = ({ value, removeSpaces = false, copyable = true, style, showToolTip = true, ...rest }) => {
  return (
    <Paragraph
      copyable={
        copyable
          ? {
              icon: [<MdContentCopy key="copy-icon" />, <IoCheckmarkCircle key="copied-icon" />],
              text: removeSpaces ? value?.replace(/\s/g, '') : value,
              tooltips: showToolTip,
            }
          : false
      }
      className={styles.copyable}
      style={{ marginBottom: 0, ...style }}
      {...rest}
    >
      {value}
    </Paragraph>
  );
};
export default TextCopy;
